import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import { useGetProfileQuery } from '../../Redux/Api/Contractor';
import { hasStoredSession } from '../../utils/session';
import { Loading } from '../../common/Loader';

type PrivateRouteProps = {
  roles: string[]; // Define roles as an array of strings
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ roles }) => {
  const userRole = useSelector((state: RootState) => state.Login.ContractorData?.role);

  // Pehle yahan sirf redux dekha jaata tha. Hard reload par ContractorData
  // null hota hai kyunki wo sirf /global/contractor/getprofile ke jawab se
  // bharta hai — yaani logged-in dealer ko /checkout, /profile/my-orders
  // wagairah se turant "/" par phenk diya jaata tha. Ab jab tak token maujood
  // hai aur profile call chal rahi hai, hum rukte hain.
  const hasSession = hasStoredSession();
  const { data, isLoading, isFetching } = useGetProfileQuery(undefined as any, {
    skip: !hasSession,
  });

  const role = userRole || (data as any)?.role;

  if (!role) {
    if (hasSession && (isLoading || isFetching)) return <Loading />;
    return <Navigate to="/" replace />;
  }

  // Check if user role matches authorized roles
  if (!roles.includes(role)) {
    // Redirect to unauthorized page or home if not authorized
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
